export default "__VITE_ASSET__ef3cc6b3__"